import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, lighten } from '@material-ui/core/styles';
import {
  Select, Chip, MenuItem, ListItemText, Checkbox,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import BootstrapInput from './BootstrapInput';

const useStyles = makeStyles((theme) => ({
  selectRoot: {
    display: 'inline-flex',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
    backgroundColor: (props) => (props.disabled
      ? lighten(theme.palette.secondary.main, 0.5) : theme.palette.secondary.main),
    color: 'white',
  },
  input: {
    borderColor: (props) => (props.error ? theme.palette.error.main : '#ced4da'),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const MySelectMultiple = (props) => {
  const {
    name,
    value,
    onChange,
    defaultValue,
    inputRef,
    menuItems,

    autoFocus,
    disabled,
    error,
  } = props;

  const classes = useStyles({ error, disabled });

  const [internalValues, setInternalValues] = React.useState(onChange ? value : defaultValue);

  const menus = menuItems.map((m) => (
    <MenuItem
      key={`menu-item-${name}-${m.value}`}
      value={m.value}
    >
      <Checkbox checked={internalValues.indexOf(m.value) > -1} />
      <ListItemText primary={m.label ? m.label : <FormattedMessage id={m.labelId} />} />
    </MenuItem>
  ));

  return (
    <Select
      multiple
      classes={{ root: classes.selectRoot }}
      value={value}
      onChange={(e) => {
        if (onChange) {
          onChange(e);
        }
        setInternalValues(e.target.value);
      }}
      defaultValue={defaultValue}
      inputRef={inputRef}
      input={(
        <BootstrapInput
          classes={{ input: classes.input }}
          disabled={disabled}
          name={name}
          onChange={onChange}
          inputProps={{
            autoFocus,
          }}
        />
        )}
      renderValue={(selected) => (
        <div className={classes.chips}>
          {selected.map((selectedValue) => (
            <Chip
              key={selectedValue}
              label={selectedValue.split(':')[1]}
              className={classes.chip}
            />
          ))}
        </div>
      )}
      MenuProps={MenuProps}
    >
      {menus}
    </Select>
  );
};

const mySelectMultipleValuePropTypes = PropTypes.oneOfType([PropTypes.string]);

MySelectMultiple.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(mySelectMultipleValuePropTypes),
  onChange: PropTypes.func,
  defaultValue: PropTypes.arrayOf(mySelectMultipleValuePropTypes),
  inputRef: PropTypes.any,
  menuItems: PropTypes.arrayOf(PropTypes.shape({
    value: mySelectMultipleValuePropTypes.isRequired,
    label: PropTypes.string,
    labelId: PropTypes.string,
  })),

  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
};

MySelectMultiple.defaultProps = {
  value: undefined,
  onChange: undefined,
  defaultValue: undefined,
  inputRef: undefined,
  menuItems: [],
  autoFocus: false,
  disabled: false,
  error: false,
};

export default MySelectMultiple;
